import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-salesbycategory',
  templateUrl: './salesbycategory.component.html',
  styleUrls: ['./salesbycategory.component.css']
})
export class SalesbycategoryComponent extends BaseCrudComponent {

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    totals:any;
    laboralDays:any;
    
    scrollableCols:any;
    frozenCols:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportSalesPerCategory/Post';
        this.header = {};
        this.zones = [];
        this.rows = [];
        this.totals = [];
        this.laboralDays = [];

        this.scrollableCols = [
            { field: 'ventaReal', header: 'VTA NETA REAL', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'salesNetReal'},
            { field: 'objetivoVenta', header: 'VTA OBJ', sortable:true, sortfield:'sort_objetivoVenta', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'salesGoal'},
            { field: 'cumplimiento', header: '% CUMP', sortable:true, sortfield:'sort_cumplimiento', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'%', total:'accomplishment'},
            { field: 'colorClass', header: '', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 40}, isColor:true, pre:'', pos:'', total:''},
            { field: 'margen', header: '%MARGEN', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'%', total:'margin'},
            { field: 'devoluciones', header: 'DEV $', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'return'},
            { field: 'devVenta', header: '% DEV/VTA NETA', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'%', total:'returnSalePerSalesNetReal'},
            { field: 'skuActivos', header: '# SKU Activos', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'skuVendidos', header: '# SKU Venta', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'coberturaSKU', header: '% COBERTURA SKU', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'clientesActivos', header: '# CLIE ASIGNADOS', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'clientesVenta', header: '# CLIE CON VENTA', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'penetracion', header: '% PENETRACIÓN', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'%', total:''}
        ];

        this.frozenCols = [
            { field: 'descripcion', header: 'CATEGORIAS', sortable:true, sortfield:'descripcion', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:''}
        ];
    }

    ngOnInit() {
        /*this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;*/
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.laboralDays = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Zone: null,
            //Date: this.f_datefrom
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                //console.log(rs);
                this.header = rs.header;
                this.totals = rs.totals;
                this.rows = rs.detail;
                this.laboralDays = rs.laboralDays;

                this.rows.forEach(r => {
                    let checker = parseFloat(r.cumplimiento.replace(/,/g, ''));
                    r.colorRow = r.color;
                    r.colorRowPDF = (r.color == 'X') ? 'aliceblue':'';

                	if(checker <= 80){
                		//red
                		r.color = '#ff0000';
                        //r.color = '#f52a2ac9';
                		r.colorClass = 'orangered';
                	}
                	else if(checker > 95){
                		//green
                		r.color = '#adff2f';
                		r.colorClass = 'greenyellow';
                	}
                	else{
                		//yellow
                		r.color = '#ffff00';
                		r.colorClass = 'yellow';
                	}

                    r.sort_objetivoVenta = parseFloat(r.objetivoVenta.replace(/,/g, ''));
                    r.sort_cumplimiento = parseFloat(r.cumplimiento.replace(/,/g, ''));
                });
            }
        });
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'REPORTE VENTA ACUMULADA POR CATEGORIA (VENDEDOR)', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            // {content:'' , colSpan:0},
            {content:'Fecha: ' + this.today, colSpan:2},
            // {content:'' , colSpan:0}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            // {content:'' , colSpan:0},
            {content:'Mes: ' + this.curr_date, colSpan:2},
            // {content:'' , colSpan:0},
        ]);
        obj.push([
            {content:'Días hábiles mes: ' + this.laboralDays['businessDays'] + '        Días hábiles transcurridos: ' + this.laboralDays['businessDaysElapsed'] + '         %Tiempo Transcurrido: ' + this.laboralDays['timeElapsed'], colSpan:4,styles:{ halign:'center'}},
            // {content:'Días hábiles transcurridos: ' + this.laboralDays['businessDaysElapsed'], colSpan:2},
            // {content:'%Tiempo Transcurrido: ' + this.laboralDays['timeElapsed'], colSpan:0},
            // {content:'' , colSpan:0},
        ]);

        return obj;
    }

    exportReport(){
        var doc = new jsPDF('l','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        let header = [];
        let footer = [];
        let x = [];

        header = [];
        //header.push([{content:'CLIENTES EN RUTA', colSpan:15, styles:{fontStyle:'bold', halign:'center', fontSize:10}}]);
        header.push(['CATEGORIAS', 'VTA NETA REAL', 'VTA OBJ', '% CUMP', '', '%MARGEN', 'DEV $', '% DEV/VTA NETA', '# SKU Activos', '# SKU Venta', '% COBERTURA SKU', '# CLIE ASIGNADOS', '# CLIE CON VENTA', '% PENETRACIÓN']);
        
        x = [];
        this.rows.forEach(i => {
            x.push([
                {content: i.descripcion, styles:{fillColor:i.colorRowPDF}},
                {content: '$'+i.ventaReal, styles:{halign:'right', fillColor:i.colorRowPDF}},
                {content: '$'+i.objetivoVenta, styles:{halign:'right', fillColor:i.colorRowPDF}},
                {content:i.cumplimiento+' %', styles:{fillColor:i.colorRowPDF}},
                {content:'', styles:{fillColor:i.color, cellWidth:15}},
                {content: i.margen+' %', styles:{fillColor:i.colorRowPDF}},
                {content: '$'+i.devoluciones, styles:{halign:'right',fillColor:i.colorRowPDF}},
                {content: i.devVenta+' %', styles:{fillColor:i.colorRowPDF}},
                {content: i.skuActivos, styles:{fillColor:i.colorRowPDF}},
                {content: i.skuVendidos, styles:{fillColor:i.colorRowPDF}},
                {content: i.coberturaSKU+' %', styles:{fillColor:i.colorRowPDF}},
                {content: i.clientesActivos, styles:{fillColor:i.colorRowPDF}},
                {content: i.clientesVenta, styles:{fillColor:i.colorRowPDF}},
                {content: i.penetracion+' %', styles:{fillColor:i.colorRowPDF}}
            ]);
        });

        footer = [];
        footer.push([
        	'',
            {content: '$'+this.totals.salesNetReal, styles:{halign:'right'}},
            {content: '$'+this.totals.salesGoal, styles:{halign:'right'}},
            {content: this.totals.accomplishment, styles:{halign:'center'}},
            '',
            {content: this.totals.margin, styles:{halign:'center'}},
            {content: '$'+this.totals.return, styles:{halign:'right'}},
            {content: this.totals.returnSalePerSalesNetReal, styles:{halign:'center'}},
            {content:'', colSpan:6}
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:7, fillColor:'#3e5569',halign:'center'}, bodyStyles:{fontSize:7, halign:'center'}, footStyles:{fontSize:7, fillColor:'#e9ecef', textColor:'#000'}});
        
        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('venta_acumulada_por_categoria_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
